import Avatar from "@mui/material/Avatar";
import React from "react";
import Helper from "../../Helper";
import { Team } from "../../models/Team";
import TeamInfo from "../../teamInfo";
import Tooltip from "../UI/Tooltip";

interface Props {
    team: TeamInfo | Team | null | undefined;
    size?: number;
    fontSize?: string;
    showTooltip?: boolean;
    showName?: boolean;
    variant?: "circular" | "rounded" | "square";
    className?: string;
}

export const teamAvatarUrl = (team: TeamInfo | Team | null | undefined): string =>
    // @ts-expect-error: Lots of places are passing something in as a "team"
    // param that aren't Team or TeamInfo instances constructed in a sane way,
    // but are instead constructed in some other way that causes them to not
    // fix the avatar url property correctly. Because of that we have to check
    // for a variant here that doesn't actually exist on either class.
    team?.avatarUrl || team?.avatar_url || "";

const TeamAvatar: React.FC<Props> = (props: Props) => {
    const { team } = props;
    const [uri, setUri] = React.useState<string>("");

    const subdomain = team?.subdomain || null;
    const teamName = team instanceof TeamInfo ? team.team_name : team?.teamName;

    React.useEffect(() => {
        setUri(teamAvatarUrl(team));
    }, [subdomain]);

    if (!team) {
        return null;
    }

    return (
        <Tooltip title={props.showTooltip ? teamName : ""}>
            <div className="flex flex-row items-center justify-center gap-2 rounded-lg">
                <Avatar
                    variant={props.variant ? props.variant : "rounded"}
                    src={uri}
                    sx={{
                        width: props.size ? props.size : 40,
                        height: props.size ? props.size : 40,
                    }}
                    className={Helper.classNames(props.className, props.variant == "rounded" && "rounded-lg!")}
                />

                {props.showName && <div>{teamName}</div>}
            </div>
        </Tooltip>
    );
};

export default TeamAvatar;
